// Phase 2.12 — REST-backed inviteService.

import { getAccessToken } from '../contexts/AuthContextV2';

const API_BASE = process.env.REACT_APP_API_URL ?? '';

async function apiFetch(path, options = {}) {
  const token = getAccessToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers, credentials: 'include' });
  let body = null;
  try { body = await res.json(); } catch { /* non-json */ }
  if (!res.ok) {
    const err = new Error(body?.error || `Request failed: ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const inviteService = {
  async invite({ tenantId: _tenantId, email, role = 'teacher' /* invitedBy ignored — server uses JWT */ }) {
    if (!email) throw new Error('inviteService: invalid email');
    const result = await apiFetch('/api/invites', {
      method: 'POST',
      body: JSON.stringify({ email: email.trim().toLowerCase(), role })
    });
    return { id: result.user?.id, ...result.user, alreadyExisted: !!result.alreadyExisted };
  },

  async inviteMany({ tenantId: _tenantId, emails, role = 'teacher' }) {
    if (!Array.isArray(emails) || emails.length === 0) {
      return { created: [], duplicates: [], failed: [] };
    }
    try {
      return await apiFetch('/api/invites/bulk', {
        method: 'POST',
        body: JSON.stringify({ emails, role })
      });
    } catch (err) {
      console.warn('inviteServiceV2.inviteMany failed:', err.message);
      return { created: [], duplicates: [], failed: emails.map((e) => ({ email: e, message: err.message })) };
    }
  },

  async listPending(_tenantId) {
    try {
      const { invites } = await apiFetch('/api/invites');
      return invites;
    } catch (err) {
      console.warn('inviteServiceV2.listPending failed:', err.message);
      return [];
    }
  }
};

export default inviteService;
